// Pure Höhen-Berechnung für Mobile-Bottom-Sheets.
//
// Ein Sheet darf maximal so hoch sein wie der SICHTBARE Viewport
// (visualViewport schrumpft bei offener Bildschirmtastatur), aber nie
// höher als 90% des Layout-Viewports (≙ dem bisherigen 90dvh-Verhalten
// ohne Tastatur). Ein kleiner Offset lässt oben Backdrop/Luft frei.

/** Luft zwischen Sheet-Oberkante und Visual-Viewport-Oberkante. */
export const SHEET_VIEWPORT_OFFSET_PX = 12

/** Harte Untergrenze — darunter ist ein Sheet nicht mehr bedienbar. */
export const SHEET_MIN_HEIGHT_PX = 160

/**
 * `min(90% layoutHeight, visualHeight − offset)`, geklemmt auf die
 * Mindesthöhe. Unbrauchbare Eingaben (0/NaN/negativ) fallen jeweils auf
 * die andere Kappe zurück.
 */
export function computeSheetMaxHeight(
  visualHeight: number,
  layoutHeight: number,
  offset: number = SHEET_VIEWPORT_OFFSET_PX,
): number {
  const layoutUsable = Number.isFinite(layoutHeight) && layoutHeight > 0
  const visualUsable = Number.isFinite(visualHeight) && visualHeight > 0

  const layoutCap = layoutUsable ? layoutHeight * 0.9 : Number.POSITIVE_INFINITY
  const visualCap = visualUsable ? visualHeight - offset : Number.POSITIVE_INFINITY

  const capped = Math.min(layoutCap, visualCap)
  if (!Number.isFinite(capped)) return SHEET_MIN_HEIGHT_PX
  return Math.max(SHEET_MIN_HEIGHT_PX, Math.round(capped))
}
